import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import SVGComponent from '../components/ro';

const yellow = '#f3e81c';

const ContactPage = styled.div`
  background: ${yellow};
  min-height: 100vh;
  font-family: 'Inter', Arial, sans-serif;
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: ${props => props.show ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  
  &:hover {
    color: #333;
  }
`;

const ModalTitle = styled.h2`
  color: #333;
  margin-bottom: 1.5rem;
  text-align: center;
  font-family: 'Poppins', Arial, sans-serif;
`;

const ManagerItem = styled.div`
  background: #f9f9f9;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  border-left: 4px solid #FF6B00;
`;

const ManagerTitle = styled.h3`
  color: #333;
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
`;

const ManagerInfo = styled.p`
  color: #666;
  margin: 0.25rem 0;
  font-size: 0.95rem;
`;

const PhoneLink = styled.a`
  color: #FF6B00;
  text-decoration: none;
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
  }
`;

const ContactContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  padding-top: 120px;
  
  @media (max-width: 768px) {
    padding: 1rem;
    padding-top: 100px;
  }
  
  @media (max-width: 600px) {
    padding-top: 80px;
  }
`;

const ContactTitle = styled.h1`
  color: #333;
  margin-bottom: 2rem;
  text-align: center;
  font-family: 'Poppins', Arial, sans-serif;
  font-size: 2.5rem;
  font-weight: 700;
  
  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }
`;

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background-color: #f9f9f9;
  padding: 2rem;
  border-radius: 8px;
  
  @media (max-width: 768px) {
    padding: 1.5rem;
    gap: 1rem;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Label = styled.label`
  font-weight: 500;
  color: #333;
`;

const Input = styled.input`
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
`;

const Textarea = styled.textarea`
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  min-height: 150px;
  resize: vertical;
`;

const SubmitButton = styled.button`
  background: #FF6B00;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 107, 0, 0.3);
  
  &:hover {
    background: #E55A00;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 107, 0, 0.4);
  }
  
  &:active {
    transform: translateY(-1px);
  }
`;

const ContactInfo = styled.div`
  margin-top: 3rem;
`;

const MapContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  padding: 2rem;
  
  @media (max-width: 768px) {
    padding: 1rem;
    margin-top: 1rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.5rem;
  }
`;

const MapWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 800px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  padding: 2rem;
  
  @media (max-width: 768px) {
    padding: 1.5rem;
    max-width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

const StyledSVGComponent = styled(SVGComponent)`
  width: 150%;
  height: auto;
  max-width: 1200px;
  max-height: 800px;
  transform: scale(1.2);
  
  @media (max-width: 768px) {
    width: 130%;
    max-width: 100%;
    max-height: 600px;
    transform: scale(1.1);
  }
  
  @media (max-width: 480px) {
    width: 110%;
    max-height: 400px;
    transform: scale(1.05);
  }
`;

const ContactInfoTitle = styled.h2`
  color: #333;
  margin-bottom: 1rem;
  text-align: center;
  font-family: 'Poppins', Arial, sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
`;

const ContactInfoList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const ContactInfoItem = styled.div`
  background: white;
  padding: 2rem 1.5rem;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 107, 0, 0.1);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    border-color: rgba(255, 107, 0, 0.3);
  }
`;

const ContactInfoIcon = styled.div`
  font-size: 2.5rem;
  color: #FF6B00;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 70px;
  background: rgba(255, 107, 0, 0.1);
  border-radius: 50%;
  margin: 0 auto 1rem auto;
  transition: all 0.3s ease;
  
  ${ContactInfoItem}:hover & {
    background: rgba(255, 107, 0, 0.2);
    transform: scale(1.1);
  }
`;

const ContactInfoText = styled.p`
  color: #444;
  font-size: 1.1rem;
  font-weight: 500;
  margin: 0;
  line-height: 1.5;

  &.address {
    font-size: 1rem;
    line-height: 1.6;
  }

  &.phone, &.email {
    font-family: 'Roboto', monospace;
    letter-spacing: 0.5px;
  }
`;

const GoogleMapsContainer = styled.div`
  background: ${yellow};
  padding: 3rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    padding: 2.5rem 1.5rem;
  }
  
  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const GoogleMapsTitle = styled.h2`
  color: #333;
  margin-bottom: 2rem;
  text-align: center;
  font-family: 'Poppins', Arial, sans-serif;
  font-size: 2rem;
  font-weight: 700;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: 1.8rem;
    margin-bottom: 1.8rem;
  }
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }
`;

const GoogleMapsWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 1rem;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    max-width: 700px;
  }
  
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const GoogleMapsAddress = styled.p`
  color: #333;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
  margin: 0;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: 1.05rem;
    padding: 0.9rem;
  }
  
  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0.8rem;
  }
`;

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [showIasiModal, setShowIasiModal] = useState(false);
  const [showBacauModal, setShowBacauModal] = useState(false);
  const [showVasluiModal, setShowVasluiModal] = useState(false);
  const [showPrahovaModal, setShowPrahovaModal] = useState(false);
  const [showVranceaModal, setShowVranceaModal] = useState(false);
  const [showBuzauModal, setShowBuzauModal] = useState(false);
  const [showGiurgiuModal, setShowGiurgiuModal] = useState(false);
  const [showGalatiModal, setShowGalatiModal] = useState(false);
  const [showNeamtModal, setShowNeamtModal] = useState(false);
  const [showBotosaniModal, setShowBotosaniModal] = useState(false);
  const [showSuceavaModal, setShowSuceavaModal] = useState(false);
  const [showBrailaModal, setShowBrailaModal] = useState(false);
  const [showArgesModal, setShowArgesModal] = useState(false);
  const [showTulceaModal, setShowTulceaModal] = useState(false);
  const [showIalomitaModal, setShowIalomitaModal] = useState(false);
  const [showCalarasiModal, setShowCalarasiModal] = useState(false);
  const [showTeleormanModal, setShowTeleormanModal] = useState(false);
  const [showConstantaModal, setShowConstantaModal] = useState(false);
  const [showDambovitaModal, setShowDambovitaModal] = useState(false);
  const [showIlfovModal, setShowIlfovModal] = useState(false);
  const [showBrasovModal, setShowBrasovModal] = useState(false);
  const [showBucharestModal, setShowBucharestModal] = useState(false);
  const [showCovasnaModal, setShowCovasnaModal] = useState(false);
  const [showHarghitaModal, setShowHarghitaModal] = useState(false);
  
  // Добавляем обработчики для клика по регионам
  React.useEffect(() => {
    window.showIasiInfo = () => {
      setShowIasiModal(true);
    };
    
    window.showBacauInfo = () => {
      setShowBacauModal(true);
    };
    
    window.showVasluiInfo = () => {
      setShowVasluiModal(true);
    };
    
    window.showPrahovaInfo = () => {
      setShowPrahovaModal(true);
    };
    
    window.showVranceaInfo = () => {
      setShowVranceaModal(true);
    };
    
    window.showBuzauInfo = () => {
      setShowBuzauModal(true);
    };
    
    window.showGiurgiuInfo = () => {
      setShowGiurgiuModal(true);
    };
    
    window.showGalatiInfo = () => {
      setShowGalatiModal(true);
    };
    
    window.showNeamtInfo = () => {
      setShowNeamtModal(true);
    };
    
    window.showBotosaniInfo = () => {
      setShowBotosaniModal(true);
    };
    
    window.showSuceavaInfo = () => {
      setShowSuceavaModal(true);
    };
    
    window.showBrailaInfo = () => {
      setShowBrailaModal(true);
    };
    
    window.showArgesInfo = () => {
      setShowArgesModal(true);
    };
    
    window.showTulceaInfo = () => {
      setShowTulceaModal(true);
    };
    
    window.showIalomitaInfo = () => {
      setShowIalomitaModal(true);
    };
    
    window.showCalarasiInfo = () => {
      setShowCalarasiModal(true);
    };
    
    window.showTeleormanInfo = () => {
      setShowTeleormanModal(true);
    };
    
    window.showConstantaInfo = () => {
      setShowConstantaModal(true);
    };
    
    window.showDambovitaInfo = () => {
      setShowDambovitaModal(true);
    };
    
    window.showIlfovInfo = () => {
      setShowIlfovModal(true);
    };
    
    window.showBrasovInfo = () => {
      setShowBrasovModal(true);
    };
    
    window.showBucharestInfo = () => {
      setShowBucharestModal(true);
    };
    
    window.showCovasnaInfo = () => {
      setShowCovasnaModal(true);
    };
    
    window.showHarghitaInfo = () => {
      setShowHarghitaModal(true);
    };
    
    return () => {
      delete window.showIasiInfo;
      delete window.showBacauInfo;
      delete window.showVasluiInfo;
      delete window.showPrahovaInfo;
      delete window.showVranceaInfo;
      delete window.showBuzauInfo;
      delete window.showGiurgiuInfo;
      delete window.showGalatiInfo;
      delete window.showNeamtInfo;
      delete window.showBotosaniInfo;
      delete window.showSuceavaInfo;
      delete window.showBrailaInfo;
      delete window.showArgesInfo;
      delete window.showTulceaInfo;
      delete window.showIalomitaInfo;
      delete window.showCalarasiInfo;
      delete window.showTeleormanInfo;
      delete window.showConstantaInfo;
      delete window.showDambovitaInfo;
      delete window.showIlfovInfo;
      delete window.showBrasovInfo;
      delete window.showBucharestInfo;
      delete window.showCovasnaInfo;
      delete window.showHarghitaInfo;
    };
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Создаем mailto ссылку с данными формы
    const emailBody = `Nume: ${formData.name}\nEmail: ${formData.email}\nSubiect: ${formData.subject}\n\nMesaj:\n${formData.message}`;
    const mailtoLink = `mailto:vanzari@banzairomania.ro?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(emailBody)}`;
    
    // Открываем почтовый клиент
    window.location.href = mailtoLink;
    
    // Показываем сообщение об успехе
    alert('Mesajul a fost pregătit pentru trimitere! Vă mulțumim pentru contactare.');
    
    // Очищаем форму
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };
  
  return (
    <ContactPage>
      <Header backgroundYellow={true} />
      <ContactContainer>
        <ContactTitle>Contactați-ne</ContactTitle>
        
        <ContactForm onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="name">Nume</Label>
            <Input 
              type="text" 
              id="name" 
              value={formData.name}
              onChange={handleChange}
              required 
            />
          </FormGroup>
          
          <FormGroup>
            <Label htmlFor="email">Email</Label>
            <Input 
              type="email" 
              id="email" 
              value={formData.email}
              onChange={handleChange}
              required 
            />
          </FormGroup>
          
          <FormGroup>
            <Label htmlFor="subject">Subiect</Label>
            <Input 
              type="text" 
              id="subject" 
              value={formData.subject}
              onChange={handleChange}
              required 
            />
          </FormGroup>
          
          <FormGroup>
            <Label htmlFor="message">Mesaj</Label>
            <Textarea 
              id="message" 
              value={formData.message}
              onChange={handleChange}
              required
            ></Textarea>
          </FormGroup>
          
          <SubmitButton type="submit">Trimite mesaj</SubmitButton>
        </ContactForm>
        
        <ContactInfo>
          <ContactInfoTitle>Filiale</ContactInfoTitle>
          <MapContainer>
            <MapWrapper>
              <StyledSVGComponent />
            </MapWrapper>
          </MapContainer>
        </ContactInfo>
      </ContactContainer>
      
      {/* Google Maps Section */}
      <GoogleMapsContainer>
        <GoogleMapsTitle>Locația noastră</GoogleMapsTitle>
        <GoogleMapsWrapper>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2712.123456789!2d27.7010216!3d47.130503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40caf8da2925aa35%3A0x8dad9bd35d55dd3e!2sStrada%20Stupinelor%203%2C%20Tome%C8%99ti%20707515%2C%20Romania!5e0!3m2!1sen!2sro!4v1234567890123!5m2!1sen!2sro"
            width="100%"
            height="400"
            style={{ border: 0, borderRadius: '12px' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Locația noastră - Tomesti, Strada Stupinelor nr 3, Iași 707515"
          ></iframe>
        </GoogleMapsWrapper>
        <GoogleMapsAddress>
          📍 Tomesti, Strada Stupinelor nr 3, Iași 707515
        </GoogleMapsAddress>
      </GoogleMapsContainer>
      
      <Modal show={showIasiModal} onClick={() => setShowIasiModal(false)}>
        <ModalContent onClick={(e) => e.stopPropagation()}>
          <CloseButton onClick={() => setShowIasiModal(false)}>×</CloseButton>
          <ModalTitle>Filiala Iasi</ModalTitle>
          
          <ManagerItem>
            <ManagerTitle>Manager 1</ManagerTitle>
            <ManagerInfo>Telefon: <PhoneLink href="tel:0757579404">0757 579 404</PhoneLink></ManagerInfo>
          </ManagerItem>
          
          <ManagerItem>
            <ManagerTitle>Manager 2</ManagerTitle>
            <ManagerInfo>Telefon: <PhoneLink href="tel:0757579403">0757 579 403</PhoneLink></ManagerInfo>
          </ManagerItem>
          
          <ManagerItem>
            <ManagerTitle>Manager 3</ManagerTitle>
            <ManagerInfo>Telefon: <PhoneLink href="tel:0742264573">0742 264 573</PhoneLink></ManagerInfo>
          </ManagerItem>
          
          <ManagerItem>
            <ManagerTitle>Manager 4 </ManagerTitle>
            <ManagerInfo>Telefon: <PhoneLink href="tel:0757579401">0757 579 401</PhoneLink></ManagerInfo>
          </ManagerItem>
          
          <ManagerItem>
            <ManagerTitle>Manager 5 </ManagerTitle>
            <ManagerInfo>Telefon: <PhoneLink href="tel:">Contactați pentru detalii</PhoneLink></ManagerInfo>
          </ManagerItem>
        </ModalContent>
      </Modal>
      
      <Modal show={showBacauModal} onClick={() => setShowBacauModal(false)}>
        <ModalContent onClick={(e) => e.stopPropagation()}>
          <CloseButton onClick={() => setShowBacauModal(false)}>×</CloseButton>
          <ModalTitle>Filiala Bacau</ModalTitle>
          
          <ManagerItem>
            <ManagerTitle>Director</ManagerTitle>
            <ManagerInfo>Telefon: <PhoneLink href="tel:0757579405">0757 579 405</PhoneLink></ManagerInfo>
          </ManagerItem>
          
          <ManagerItem>
            <ManagerTitle>Manager 1</ManagerTitle>
            <ManagerInfo>Telefon: <PhoneLink href="tel:0748249936">0748 249 936</PhoneLink></ManagerInfo>
          </ManagerItem>
          
          <ManagerItem>
            <ManagerTitle>Manager 2 </ManagerTitle>
            <ManagerInfo>Telefon: <PhoneLink href="tel:0757577461">0757 577 461</PhoneLink></ManagerInfo>
          </ManagerItem>
          
          <ManagerItem>
            <ManagerTitle>Manager 3 </ManagerTitle>
            <ManagerInfo>Telefon: <PhoneLink href="tel:0757577461">0757 577 461</PhoneLink></ManagerInfo>
          </ManagerItem>
          
          <ManagerItem>
            <ManagerTitle>Manager 4 </ManagerTitle>
            <ManagerInfo>Telefon: <PhoneLink href="tel:0757577461">0757 577 461</PhoneLink></ManagerInfo>
          </ManagerItem>
        </ModalContent>
       </Modal>
       
       <Modal show={showVasluiModal} onClick={() => setShowVasluiModal(false)}>
         <ModalContent onClick={(e) => e.stopPropagation()}>
           <CloseButton onClick={() => setShowVasluiModal(false)}>×</CloseButton>
           <ModalTitle>Filiala Vaslui</ModalTitle>
           
           <ManagerItem>
             <ManagerTitle>Director</ManagerTitle>
             <ManagerInfo>Telefon: <PhoneLink href="tel:0757579402">0757 579 402</PhoneLink></ManagerInfo>
           </ManagerItem>
           
           <ManagerItem>
             <ManagerTitle>Manager 1 - Vaslui/Galati</ManagerTitle>
             <ManagerInfo>Telefon: <PhoneLink href="tel:0740093449">0740 093 449</PhoneLink></ManagerInfo>
           </ManagerItem>
         </ModalContent>
       </Modal>
       
       <Modal show={showPrahovaModal} onClick={() => setShowPrahovaModal(false)}>
         <ModalContent onClick={(e) => e.stopPropagation()}>
           <CloseButton onClick={() => setShowPrahovaModal(false)}>×</CloseButton>
           <ModalTitle>Filiala Prahova</ModalTitle>
           
           <ManagerItem>
             <ManagerTitle>Director</ManagerTitle>
             <ManagerInfo>Telefon: <PhoneLink href="tel:0741139627">0741 139 627</PhoneLink></ManagerInfo>
           </ManagerItem>
           
           <ManagerItem>
             <ManagerTitle>Manager 1</ManagerTitle>
             <ManagerInfo>Telefon: <PhoneLink href="tel:0741125683">0741 125 683</PhoneLink></ManagerInfo>

           </ManagerItem>
           
           <ManagerItem>
             <ManagerTitle>Manager 2</ManagerTitle>
             <ManagerInfo>Telefon: <PhoneLink href="tel:0753066402">0753 066 402</PhoneLink></ManagerInfo>
            
           </ManagerItem>
         </ModalContent>
       </Modal>
       
       <Modal show={showVranceaModal} onClick={() => setShowVranceaModal(false)}>
         <ModalContent onClick={(e) => e.stopPropagation()}>
           <CloseButton onClick={() => setShowVranceaModal(false)}>×</CloseButton>
           <ModalTitle>Filiala Vrancea</ModalTitle>
           
           <ManagerItem>
             <ManagerTitle>Manager 1</ManagerTitle>
             <ManagerInfo>Telefon: <PhoneLink href="tel:0756721229">0756 721 229</PhoneLink></ManagerInfo>
           </ManagerItem>
         </ModalContent>
       </Modal>
       
       <Modal show={showBuzauModal} onClick={() => setShowBuzauModal(false)}>
         <ModalContent onClick={(e) => e.stopPropagation()}>
           <CloseButton onClick={() => setShowBuzauModal(false)}>×</CloseButton>
           <ModalTitle>Filiala Buzau</ModalTitle>
           
           <ManagerItem>
             <ManagerTitle>Manager 1</ManagerTitle>
             <ManagerInfo>Telefon: <PhoneLink href="tel:0756721229">0756 721 229</PhoneLink></ManagerInfo>
           </ManagerItem>
         </ModalContent>
       </Modal>
       
       <Modal show={showGiurgiuModal} onClick={() => setShowGiurgiuModal(false)}>
         <ModalContent onClick={(e) => e.stopPropagation()}>
           <CloseButton onClick={() => setShowGiurgiuModal(false)}>×</CloseButton>
           <ModalTitle>Filiala Giurgiu</ModalTitle>
           
           <ManagerItem>
             <ManagerTitle>Manager</ManagerTitle>
             <ManagerInfo>Telefon: <PhoneLink href="tel:0753066401">0753 066 401</PhoneLink></ManagerInfo>
           </ManagerItem>
         </ModalContent>
       </Modal>
       
       <Modal show={showGalatiModal} onClick={() => setShowGalatiModal(false)}>
         <ModalContent onClick={(e) => e.stopPropagation()}>
           <CloseButton onClick={() => setShowGalatiModal(false)}>×</CloseButton>
           <ModalTitle>Filiala Galati</ModalTitle>
           
           <ManagerItem>
             <ManagerTitle>Manager 1</ManagerTitle>
             <ManagerInfo>Telefon: <PhoneLink href="tel:0756721229">0756 721 229</PhoneLink></ManagerInfo>
           </ManagerItem>
         </ModalContent>
       </Modal>
       
       <Modal show={showNeamtModal} onClick={() => setShowNeamtModal(false)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={() => setShowNeamtModal(false)}>×</CloseButton>
            <ModalTitle>Filiala Neamt</ModalTitle>
            
            <ManagerItem>
              <ManagerTitle>Manager 1</ManagerTitle>
              <ManagerInfo>Telefon: <PhoneLink href="tel:0748249936">0748 249 936</PhoneLink></ManagerInfo>
            </ManagerItem>
            
            <ManagerItem>
              <ManagerTitle>Manager 2</ManagerTitle>
              <ManagerInfo>Telefon: <PhoneLink href="tel:0757577461">0757 577 461</PhoneLink></ManagerInfo>
            </ManagerItem>
           </ModalContent>
         </Modal>
         
         <Modal show={showBotosaniModal} onClick={() => setShowBotosaniModal(false)}>
           <ModalContent onClick={(e) => e.stopPropagation()}>
             <CloseButton onClick={() => setShowBotosaniModal(false)}>×</CloseButton>
             <ModalTitle>Filiala Botosani</ModalTitle>
             
             <ManagerItem>
               <ManagerTitle>Manager 1</ManagerTitle>
               <ManagerInfo>Telefon: <PhoneLink href="tel:0757575805">0757 575 805</PhoneLink></ManagerInfo>
             </ManagerItem>
             
             <ManagerItem>
               <ManagerTitle>Manager 2</ManagerTitle>
               <ManagerInfo>Telefon: <PhoneLink href="tel:0756721224">0756 721 224</PhoneLink></ManagerInfo>
             </ManagerItem>
             
             <ManagerItem>
               <ManagerTitle>Manager 3</ManagerTitle>
               <ManagerInfo>Telefon: <PhoneLink href="tel:0757570826">0757 570 826</PhoneLink></ManagerInfo>
             </ManagerItem>
           </ModalContent>
         </Modal>
         
         <Modal show={showSuceavaModal} onClick={() => setShowSuceavaModal(false)}>
           <ModalContent onClick={(e) => e.stopPropagation()}>
             <CloseButton onClick={() => setShowSuceavaModal(false)}>×</CloseButton>
             <ModalTitle>Filiala Suceava</ModalTitle>
             
             <ManagerItem>
               <ManagerTitle>Director</ManagerTitle>
               <ManagerInfo>Telefon: <PhoneLink href="tel:0756721241">0756 721 241</PhoneLink></ManagerInfo>
             </ManagerItem>
             
             <ManagerItem>
               <ManagerTitle>Manager 1</ManagerTitle>
               <ManagerInfo>Telefon: <PhoneLink href="tel:0757575805">0757 575 805</PhoneLink></ManagerInfo>
             </ManagerItem>
             
             <ManagerItem>
               <ManagerTitle>Manager 2</ManagerTitle>
               <ManagerInfo>Telefon: <PhoneLink href="tel:0756721224">0756 721 224</PhoneLink></ManagerInfo>
             </ManagerItem>
             
             <ManagerItem>
               <ManagerTitle>Manager 3</ManagerTitle>
               <ManagerInfo>Telefon: <PhoneLink href="tel:0757570826">0757 570 826</PhoneLink></ManagerInfo>
             </ManagerItem>
           </ModalContent>
         </Modal>
         
         <Modal show={showBrailaModal} onClick={() => setShowBrailaModal(false)}>
           <ModalContent onClick={(e) => e.stopPropagation()}>
             <CloseButton onClick={() => setShowBrailaModal(false)}>×</CloseButton>
             <ModalTitle>Filiala Braila</ModalTitle>
             
             <ManagerItem>
               <ManagerTitle>Director</ManagerTitle>
               <ManagerInfo>Telefon: <PhoneLink href="tel:0757575569">0757 575 569</PhoneLink></ManagerInfo>
             </ManagerItem>
             
             <ManagerItem>
               <ManagerTitle>Manager 1</ManagerTitle>
               <ManagerInfo>Telefon: <PhoneLink href="tel:0756721224">0756 721 224</PhoneLink></ManagerInfo>
             </ManagerItem>
             
             <ManagerItem>
               <ManagerTitle>Manager 2</ManagerTitle>
               <ManagerInfo>Telefon: <PhoneLink href="tel:0741148421">0741 148 421</PhoneLink></ManagerInfo>
             </ManagerItem>
           </ModalContent>
         </Modal>
         
         <Modal show={showArgesModal} onClick={() => setShowArgesModal(false)}>
           <ModalContent onClick={(e) => e.stopPropagation()}>
             <CloseButton onClick={() => setShowArgesModal(false)}>×</CloseButton>
             <ModalTitle>Filiala Argeș</ModalTitle>
             
             <ManagerItem>
               <ManagerTitle>Director</ManagerTitle>
               <ManagerInfo>Telefon: <PhoneLink href="tel:0756039571">0756 039 571</PhoneLink></ManagerInfo>
             </ManagerItem>
           </ModalContent>
         </Modal>
         
         <Modal show={showTulceaModal} onClick={() => setShowTulceaModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <CloseButton onClick={() => setShowTulceaModal(false)}>×</CloseButton>
              <ModalTitle>Filiala Tulcea</ModalTitle>
              
              <ManagerItem>
                 <ManagerTitle>Director</ManagerTitle>
                 <ManagerInfo>Telefon: <PhoneLink href="tel:0757575569">0757 575 569</PhoneLink></ManagerInfo>
               </ManagerItem>
               
               <ManagerItem>
                 <ManagerTitle>Manager</ManagerTitle>
                 <ManagerInfo>Telefon: <PhoneLink href="tel:0756721224">0756 721 224</PhoneLink></ManagerInfo>
               </ManagerItem>
            </ModalContent>
          </Modal>

          <Modal show={showIalomitaModal} onClick={() => setShowIalomitaModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <CloseButton onClick={() => setShowIalomitaModal(false)}>×</CloseButton>
              <ModalTitle>Filiala Ialomița</ModalTitle>
              
              <ManagerItem>
                <ManagerTitle>Director</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0748249935">0748 249 935</PhoneLink></ManagerInfo>
              </ManagerItem>
              
              <ManagerItem>
                <ManagerTitle>Manager 1</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0741125683">0741 125 683</PhoneLink></ManagerInfo>
              </ManagerItem>
            </ModalContent>
          </Modal>
          
          <Modal show={showCalarasiModal} onClick={() => setShowCalarasiModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <CloseButton onClick={() => setShowCalarasiModal(false)}>×</CloseButton>
              <ModalTitle>Filiala Călărași</ModalTitle>
              
              <ManagerItem>
                <ManagerTitle>Director</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0748249935">0748 249 935</PhoneLink></ManagerInfo>
              </ManagerItem>
              
              <ManagerItem>
                <ManagerTitle>Manager</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0753066402">0753 066 402</PhoneLink></ManagerInfo>
              </ManagerItem>
            </ModalContent>
          </Modal>
          
          <Modal show={showTeleormanModal} onClick={() => setShowTeleormanModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <CloseButton onClick={() => setShowTeleormanModal(false)}>×</CloseButton>
              <ModalTitle>Filiala Teleorman</ModalTitle>
              
              <ManagerItem>
                <ManagerTitle>Director</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0741139627">0741 139 627</PhoneLink></ManagerInfo>
              </ManagerItem>
              
              <ManagerItem>
                <ManagerTitle>Manager</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0753066402">0753 066 402</PhoneLink></ManagerInfo>
              </ManagerItem>
            </ModalContent>
          </Modal>
          
          <Modal show={showConstantaModal} onClick={() => setShowConstantaModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <CloseButton onClick={() => setShowConstantaModal(false)}>×</CloseButton>
              <ModalTitle>Filiala Constanța</ModalTitle>
              
              <ManagerItem>
                <ManagerTitle>Director</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0753066403">0753 066 403</PhoneLink></ManagerInfo>
              </ManagerItem>
            </ModalContent>
          </Modal>
          
          <Modal show={showDambovitaModal} onClick={() => setShowDambovitaModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <CloseButton onClick={() => setShowDambovitaModal(false)}>×</CloseButton>
              <ModalTitle>Filiala Dâmbovița</ModalTitle>
              
              <ManagerItem>
                <ManagerTitle>Director</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0741139627">0741 139 627</PhoneLink></ManagerInfo>
              </ManagerItem>
            </ModalContent>
          </Modal>
          
          <Modal show={showIlfovModal} onClick={() => setShowIlfovModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <CloseButton onClick={() => setShowIlfovModal(false)}>×</CloseButton>
              <ModalTitle>Filiala Ilfov</ModalTitle>
              
              <ManagerItem>
                <ManagerTitle>Director</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0741139627">0741 139 627</PhoneLink></ManagerInfo>
              </ManagerItem>
            </ModalContent>
          </Modal>
          
          <Modal show={showBrasovModal} onClick={() => setShowBrasovModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <CloseButton onClick={() => setShowBrasovModal(false)}>×</CloseButton>
              <ModalTitle>Filiala Brașov</ModalTitle>
              
              <ManagerItem>
                <ManagerTitle>Director</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0741139627">0741 139 627</PhoneLink></ManagerInfo>
              </ManagerItem>
            </ModalContent>
          </Modal>
          
          <Modal show={showBucharestModal} onClick={() => setShowBucharestModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <CloseButton onClick={() => setShowBucharestModal(false)}>×</CloseButton>
              <ModalTitle>Filiala București</ModalTitle>
              
              <ManagerItem>
                <ManagerTitle>Director</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0741139627">0741 139 627</PhoneLink></ManagerInfo>
              </ManagerItem>
            </ModalContent>
          </Modal>
          
          <Modal show={showCovasnaModal} onClick={() => setShowCovasnaModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <CloseButton onClick={() => setShowCovasnaModal(false)}>×</CloseButton>
              <ModalTitle>Filiala Covasna</ModalTitle>
              
              <ManagerItem>
                <ManagerTitle>Director</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0757579405">0757 579 405</PhoneLink></ManagerInfo>
              </ManagerItem>
            </ModalContent>
          </Modal>
          
          <Modal show={showHarghitaModal} onClick={() => setShowHarghitaModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <CloseButton onClick={() => setShowHarghitaModal(false)}>×</CloseButton>
              <ModalTitle>Filiala Harghita</ModalTitle>
              
              <ManagerItem>
                <ManagerTitle>Director</ManagerTitle>
                <ManagerInfo>Telefon: <PhoneLink href="tel:0757579405">0757 579 405</PhoneLink></ManagerInfo>
              </ManagerItem>
            </ModalContent>
          </Modal>
       </ContactPage>
     );
 }

 export default Contact;